<script lang="ts" setup>
const { locale } = useI18n()
</script>

<template>
  <slot :name="locale" />
</template>
